import { Action } from '@ngrx/store';

export class ResponseSuccess implements Action {
  constructor(readonly type: any, readonly response: any) {}
}
